// Country code redirect for small countries
// e.g. LI is redirect to CH
const CountryCodeRedirect = {
  LI: "CH",
  SM: "CH",
};

export default CountryCodeRedirect;
